import React from 'react';

export default function SolutionDetail() {
  return <div>Solution Detail Page</div>;
}
